import { SystemMessage } from "@app/constants";
import * as Yup from "yup";

export const createVoucherActiveValidationSchema = Yup.object().shape({
  code: Yup.string().required(SystemMessage.INPUT_REQUIRED),
  name: Yup.string().required(SystemMessage.INPUT_REQUIRED),
  expiredTime: Yup.string().required(SystemMessage.INPUT_REQUIRED),
  totalUse: Yup.number()
    .required(SystemMessage.INPUT_REQUIRED)
    .integer(SystemMessage.INPUT_REQUIRED)
    .typeError(SystemMessage.INPUT_REQUIRED)
    .positive(SystemMessage.INPUT_REQUIRED),
});
